export const truncateWords = (text: string, wordLimit: number): { truncated: string; isTruncated: boolean } => {
  if (!text) return { truncated: '', isTruncated: false };

  const words = text.split(/\s+/);

  if (words.length <= wordLimit) {
    return { truncated: text, isTruncated: false };
  }

  return { truncated: words.slice(0, wordLimit).join(' ') + '...', isTruncated: true };
};
